import { gql } from "@apollo/client";

export const UPDATE_MESSAGE_TEMPLATE = gql`
  mutation UpdateMessageTemplate(
    $insert_object: message_template_insert_input!
    $update_object: message_template_set_input!
    $existing_template_id: uuid!
    $is_existing: Boolean!
    $new_content_id: uuid!
    $existing_content_id: uuid!
    $skip_delete: Boolean!
  ) {
    insert_message_template_one(object: $insert_object)
      @skip(if: $is_existing) {
      id
      enabled
    }

    update_message_template_by_pk(
      pk_columns: { id: $existing_template_id }
      _set: $update_object
    ) @include(if: $is_existing) {
      id
      enabled
    }

    insert_message_template_rich_content_one(
      object: {
        message_id: $existing_template_id
        content_id: $new_content_id
        language: "en"
      }
      on_conflict: {
        constraint: message_template_rich_content_message_id_language_key
        update_columns: [content_id]
      }
    ) @include(if: $is_existing) {
      message_id
      content_id
    }

    # Legacy content may not have language "en", so the upsert wouldn't remove it.
    # Keep this block to ensure legacy content is deleted.
    delete_message_template_rich_content(
      where: { content_id: { _eq: $existing_content_id } }
    ) @skip(if: $skip_delete) {
      affected_rows
    }
  }
`;

export const UPDATE_MESSAGE_TEMPLATES = gql`
  mutation UpdateMessageTemplates(
    $messageTemplateInserts: [message_template_insert_input!] = []
    $messageTemplateUpdates: [message_template_updates!] = []
  ) {
    insert_message_template(objects: $messageTemplateInserts) {
      affected_rows
      returning {
        id
        type
        school_id
        email_subject
        email_markup
        email_plain_text
        sms_body
        enabled
        message_template_rich_contents {
          content_id
          language
        }
      }
    }
    update_message_template_many(updates: $messageTemplateUpdates) {
      affected_rows
    }
  }
`;
